import createLucideIcon from '../createLucideIcon';

const FlagTriangleLeft = createLucideIcon('FlagTriangleLeft', [
  ['path', { d: 'M17 22V2L7 7l10 5', key: '1rmf0r' }],
]);

export default FlagTriangleLeft;
